import { CommonModule } from '@angular/common';
import { ChangeDetectionStrategy, Component } from '@angular/core';

@Component({
  selector: 'app-my-partners',
  templateUrl: 'my-partners.component.html',
  styleUrls: ['./my-partners.component.css'],
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class MyPartnersComponent {
  namefile: String;
  constructor() {}
  ngOnInit() {}
  uploadFile(event: any): void {
    let file = event.target.files[0];
    this.namefile = file.name;
  }
}
